<template>
  <div>
    <b-tabs
      align="center"
      active-nav-item-class="font-weight-bold text-secondary border-0"
      active-tab-class="font-weight-bold text-dark"
      content-class="mt-3"
      nav-class="border-0 text-white"
      no-key-nav
      v-model="regIndex"
    >
      <b-tab title="mail" active title-item-class="disabled__nav">
        <div class="row px-4 mx-4 col-sm-10 col-lg-8 mx-auto">
          <div class="col mx-4">
            <b-form @submit="onSubmitFirst" v-if="show">
              <b-form-input class="hidden" id="hpot" v-model="form.hpot"></b-form-input>

              <h2 class="text-left text-black">Benvenuto</h2>
              <b-form-input
                v-model="form.email"
                type="email"
                id="email"
                required
                placeholder="La tua email"
                class="my-4 p-3 border-secondary big__input"
              ></b-form-input>
              <b-form-input
                v-model="form.password"
                type="password"
                id="password"
                required
                :state="form.email ? minRequired : null"
                placeholder="La tua password"
                class="my-4 big__input border-secondary"
              ></b-form-input>
              <b-form-input
                v-model="form.password_confirmation"
                type="password"
                id="password_confirmation"
                required
                placeholder="Conferma password"
                class="mt-4 mb-2 p-3 border-secondary big__input"
                :state="
                  form.password && form.password_confirmation == form.password
                    ? minRequired
                    : null
                "
                :class="
                  form.password !== form.password_confirmation &&
                    'border-danger'
                "
              ></b-form-input>
              <div class="row mx-auto text center pt-1">
                <p
                  class="small__txt text-left"
                >*La password deve contenere un minimo di 8 caratteri ed includere almeno 1 numero, 1 maiuscola ed 1 minuscola.</p>
              </div>

              <div class="row mx-auto text center pt-1">
                <b-button
                  type="submit"
                  variant="secondary"
                  class="font-weight-bold ml-auto mr-2"
                  :disabled="disableBtn"
                >Registrati</b-button>
                <b-button
                  type="button"
                  variant="primary"
                  class="font-weight-bold ml-2 mr-auto"
                  @click="toLogin"
                >Accedi</b-button>
              </div>
            </b-form>
          </div>
          <div class="col-5 mx-auto align-content-center px-0">
            <h2 class="text-left text-white">Benvenuto</h2>
            <div class="image__div">
              <DottorLogo />
            </div>
          </div>
        </div>
      </b-tab>
      <b-tab title="tipologia" title-item-class="disabled__nav">
        <h2 class="text-black pb-3 text-center">Sono un</h2>
        <br v-if="!isMobile" />
        <div
          class="row justify-content-center line__bg mx-auto"
          :class="!isMobile && ' mt-3'"
          :style="
            !isMobile && { 'background-image': `url(${'/svg/line.svg'})` }
          "
        >
          <div
            class="point border-primary rounded-circle min__h text-primary d-flex align-items-center justify-content-center"
            :class="isMobile ? 'mx-auto my-1' : 'mr-3'"
            @click="setType('professionista')"
          >
            <MedicoLogo class="icon__primary icon__size" />
            <span>Professionista</span>
          </div>
          <div
            class="point border-secondary rounded-circle min__h text-secondary d-flex align-items-center justify-content-center"
            :class="isMobile ? 'mx-auto my-1' : 'ml-3'"
            @click="setType('paziente')"
          >
            <PazienteLogo class="icon__secondary icon__size" />
            <span>Paziente</span>
          </div>
        </div>
        <div class="row mx-auto text-center pt-1 my-2">
          <b-button
            type="button"
            variant="primary"
            class="font-weight-bold mx-auto"
            @click="regIndex--"
          >Indietro</b-button>
        </div>
      </b-tab>
      <b-tab title="ruolo" title-item-class="disabled__nav">
        <br />
        <b-form
          @submit="onSubmit"
          class="col-sm-10 col-lg-6 mx-auto pt-4"
          :class="!isMobile && 'mt-4'"
        >
          <b-overlay :show="registering" rounded="sm" class="mx-auto">
            <b-form-select
              v-if="form.tipologia === 'professionista'"
              id="input-3"
              class="my-4"
              v-model="form.ruolo"
              :options="ruoli"
              required
            ></b-form-select>
            <b-form-group
              label="Accetto termini e condizioni*"
              description="E' necessario accettare termini e condizioni per l'utilizzo del servizio"
              class="mb-1 mx-auto text-center"
            >
              <a
                href="https://teleconsulto.online/tec/"
                class="text-secondary small__txt pb-1"
                target="_blank"
              >*vedi termini e condizioni</a>
              <b-form-radio-group
                v-model="form.termini_condizioni"
                name="termini_condizioni"
                required
              >
                <b-form-radio :value="true">Sì</b-form-radio>
                <b-form-radio :value="false">No</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
            <b-form-group
              label="Consenso al trattamento dei dati*"
              description="E' necessario il consenso al trattamento dei dati personali"
              class="mb-1 mx-auto text-center"
            >
              <a
                href="https://teleconsulto.online/privacy"
                class="text-secondary small__txt pb-1"
                target="_blank"
              >*vedi privacy policy</a>
              <b-form-radio-group v-model="form.consenso_dati" name="consenso_dati" required>
                <b-form-radio :value="true">Sì</b-form-radio>
                <b-form-radio :value="false">No</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
            <b-form-group label="Consenso alle notifiche" class="mb-1 mx-auto text-center">
              <b-form-radio-group
                v-model="form.consenso_notifiche"
                name="consenso_notifiche"
                required
                variant="secondary"
              >
                <b-form-radio :value="true">Sì</b-form-radio>
                <b-form-radio :value="false">No</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
            <div v-show="showAlert" class="my-2">
              <span class="text-danger">
                Per utilizzare l'applicazione sono necessari il consenso al
                trattamento dei dati personali e l'accettazione di termini e
                servizi
              </span>
            </div>
            <div class="text-danger my-1">{{errorMsgs}}</div>

            <div class="row mx-auto text center pt-1">
              <b-button
                type="button"
                variant="primary"
                class="font-weight-bold ml-auto mr-2"
                @click="regIndex--"
              >Indietro</b-button>
              <b-button
                type="submit"
                variant="secondary"
                class="font-weight-bold mr-auto ml-2"
              >Registrati</b-button>
            </div>
          </b-overlay>
        </b-form>
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
import PazienteLogo from "@/../public/svg/paziente.svg";
import MedicoLogo from "@/../public/svg/medico.svg";
import DottorLogo from "@/../public/svg/dottor.svg";
export default {
  name: "register",
  components: { DottorLogo, PazienteLogo, MedicoLogo },
  data() {
    return {
      regIndex: 0,
      form: {
        email: "",
        password: "",
        password_confirmation: "",
        hpot: null,
        ruolo: "paziente",
        tipologia: null,
        termini_condizioni: false,
        consenso_dati: false,
        consenso_notifiche: false
      },
      ruoli: [
        { text: "Seleziona categoria professionista", value: "paziente" }
      ],
      tipologie: [
        { text: "Registrati come", value: null },
        "paziente",
        "professionista"
      ],
      show: true,
      showAlert: false,
      registering: false,
      errorMsgs: null
    };
  },
  computed: {
    isMobile: function() {
      return this.$root.device < 575;
    },
    minRequired: function() {
      var space = this.form.password.indexOf(" ");
      if (space < 0) {
        var strongRegex = new RegExp(
          "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})"
        );
        return strongRegex.test(this.form.password);
      }
      return false;
    },
    disableBtn: function() {
      if (this.minRequired) {
        if (this.form.password === this.form.password_confirmation) {
          return false;
        }
        return true;
      }
      return true;
    }
  },
  methods: {
    onSubmitFirst(evt) {
      evt.preventDefault();
      this.regIndex++;
    },
    onSubmit(evt) {
      this.registering = true;
      evt.preventDefault();
      this.validate() && this.register();
    },
    validate() {
      if (
        this.form.consenso_dati === true &&
        this.form.termini_condizioni === true
      ) {
        return this.form.hpot === null && true;
      }
      this.showAlert = true;
      this.registering = false;
      return false;
    },
    getRuoli() {
      var url = process.env.VUE_APP_VERSION + "ruolo/all";
      this.$axios
        .get(url)
        .then(res => {
          // console.log(res);
          res.data.data.map(val => {
            this.ruoli.push(val);
          });
        })
        .catch(err => {
          console.log(err);
        });
    },
    register() {
      // this.$store
      //   .dispatch("register", this.form)
      //   .then(() => {
      //     this.$emit("logged-in");
      //   })
      //   .then(() => {
      //     this.$router.push({ name: "RegisterAnagrafica" });
      //   });

      this.$axios
        .post("/register", this.form)
        .then(res => {
          // console.log(res);
          this.$emit("logged-in");
          this.registering = false;
          this.$router.push({ name: "VerifyEmail" });
        })
        .catch(err => {
          this.registering = false;
          // if (err.response.status === 422) {
          //   console.log("errore", err.response);
          //   this.errorMsgs = err.response.errors["email"];
          //   console.log(this.errorMsgs);
          // }
          if (err.response.status === 422 && err.response.data.errors.email) {
            this.errorMsgs =
              "l'indirizzo email scelto risulta già presente in piattaforma.";
          }
        });
    },
    toLogin() {
      this.$emit("update-view");
    },
    setType(type) {
      this.form.tipologia = type;
      this.regIndex++;
      // console.log(this.regIndex);
    }
  },
  created() {
    this.getRuoli();
  }
};
</script>
<style>
.small__txt {
  font-size: 0.75rem;
}
.disabled__nav {
  pointer-events: none;
  /* visibility: hidden; */
  display: none;
}
.min__h {
  min-height: 165px;
  min-width: 165px;
  max-height: 165px;
  max-width: 165px;
  border-width: 3px;
  border-style: solid;
  font-weight: 400;
  background-color: #fff;
}
svg.icon__size {
  width: 100%;
  max-height: 50px;
  max-width: 50px;
}
.line__bg {
  width: 60%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  margin: 0.5rem auto;
}
.image__div {
  /* width: "454.81";
  height: "468.97"; */
}
.a {
  fill: #ffccbc;
}
.b {
  fill: #ffab91;
}
.c {
  fill: #fff;
}
.d {
  fill: #eceff1;
}
.e {
  fill: #d1c4e9;
}
.f {
  fill: #9575cd;
}
.g {
  fill: #37474f;
}
.h {
  fill: #01579b;
}
.i {
  fill: #ff8a65;
}
.j {
  fill: #263238;
}
.k {
  fill: #4f2121;
}
.l {
  fill: #792121;
}
</style>
